const app = {
  state: {
    log: [], // 本地日志
    userId: '', // 用户ID
    appId: '', // 视频应用的APPID
    roomNumber: '', // 发起视频后的房间号
    userSign: '', // 视频应用的密钥
    news: 0, // 推送的消息条数
    inquiryRecordGuid: '', // 问诊记录GUID
    prescriptionGuid: '', // 处方id
    patientGuid: '', // 患者ID
    websocketRandom: 0,
    socketStatus: false // socket唯一
  },
  mutations: {
    /**
     * @description: 记录前端日志
     * @param {Object}
     */
    setLog: (state, logObj) => {
      const param = {
        "timestamp": logObj.timestamp, // 当前毫秒时间戳
        "time": logObj.time,
        "userId": logObj.userId, // 账号ID
        "drugstoreName": logObj.drugstoreName, // 药店名
        "phone": "", // 手机号
        "appInfo": {
          "appName": "h5-saas-patient-vue",
          "appVersion": logObj.appVersion,
          "osType": logObj.osType, // android, ios
          "osVersion": "",
          "brand": "",
          "model": "",
          "networkState": state.networkType // 网络类型
        },
        "msg": logObj.message,
        "msgCode": logObj.type, // 日志类型
        "ext": ""
      };
      const list = state.log
      list.push(param)
      state.log = list
    },
    /**
     * @description: 清除本地日志
     * @param {type}
     * @return:
     */
    resetLog: (state) => {
      state.log = []
    },
    clearSatate: (state) => {
      state.inquiryRecordGuid = ''
      state.patientGuid = ''
      state.prescriptionGuid = ''
    },
    setRandom: (state, value) => {
      state.websocketRandom = value
    },
    setInquiryRecordGuid: (state, value) => {
      state.inquiryRecordGuid = value
    },
    setRoomNumber: (state, value) => {
      state.roomNumber = value
    },
    setNetwork: (state, value) => {
      state.networkType = value
    },
    setPatientGuid: (state, value) => {
      state.patientGuid = value
    },
    // 设置用户ID
    setUserId (state, value) {
      state.userId = value
    },
    getnews (state, value) {
      if (value === 'add') {
        state.news++
        console.log('state.news', state.news)
      } else if (value === 'clear') {
        state.news = 0
      }
    },
    // 获取处方guid
    getNewsGuid (state, value) {
      console.log('设置处方guid--mutations--getNewsGuid', value)
      if (value) {
        state.prescriptionGuid = value
      }
    },
    // 设置socket唯一状态
    setSocketStatus (state, value) {
      state.socketStatus = value
    }
  },
  actions: {
    resetLog({
      commit
    }) {
      commit('resetLog')
    },
    setLog({
      commit
    }, logObj) {
      commit('setLog', logObj)
    },
    getnews ({
      commit
    }, value) {
      commit('getnews', value)
    },
    getNewsGuid ({
      commit
    }, value) {
      console.log('设置处方guid--actions--getNewsGuid', value)
      commit('getNewsGuid', value)
    },
    setSocketStatus ({
      commit
    }, value) {
      commit('setSocketStatus', value)
    }
  }
}

export default app
